export function userAgent() {
    const ua = navigator.userAgent.toLowerCase();
    const isWin = ua.indexOf("windows") !== -1;
    const isAndroid = ua.indexOf("android") !== -1;

    if (isWin || isAndroid) {
        document.documentElement.style.setProperty("--fontoffset", "0.075em");
        document.documentElement.classList.add("-win_android");
    }

    //タッチデバイスかどうかの確認
    const touch_event = window.ontouchstart;
    const touch_points = navigator.maxTouchPoints;

    if (touch_event !== undefined && 0 < touch_points) {
        window.isTouchDevice = true;
    }
}
